module.exports = __webpack_public_path__ + "img/figuura02.02340ad8.png";